import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MenuService } from '../../../../services/menu.service';
import { DataIoService } from '../../../../services/data-io.service';
import { MenuNode, Helper } from '../../../../classes';
import { LogService } from '../../../../services/log.service';
@Component({
  selector: 'screen-timeset',
  templateUrl: './timeset.component.html',
  styleUrls: ['./timeset.component.scss']
})
export class TimesetComponent implements OnInit,OnDestroy {
  _debug : boolean = false;
	mode:string;
	edit:string;
	edits : Array<string>;
	_time : Date;
  set time(data){
    this.debug("Setting time to: "+data);
    this._time = data;
  }

  get time(){
    return this._time;
  }
	title:string;
  texts:Array<string>;
	subtitle:string;
	template_parameters : Array<string>;
	
  	constructor(private menuService: MenuService,private ioService: DataIoService, private log: LogService) { 
      this.texts = new Array<string>();
  	}

  	minute(){
  		return Helper.twoDigits(this.time.getMinutes());
  	}
  	hour(){
  		return Helper.twoDigits(this.time.getHours());
  	}
  	day(){
  		return Helper.twoDigits(this.time.getDate());
  	}
  	month(){
  		return Helper.twoDigits(this.time.getMonth()+1);
  	}
  	year(){
  		return this.time.getFullYear();
  	}
    increase(val?:number){
  		if(!val){
  			val=1;
  		}
      let day = this.time.getDate();
      let month = this.time.getMonth();
      let year = this.time.getFullYear();
      let hours = this.time.getHours();
      let minutes = this.time.getMinutes();
      let seconds = this.time.getSeconds();
      let cyclic = false; // is 23 hours + 1 hour = 0 hours possible?
      // tage der monate
      let moduls = [31, (year % 4 == 0)?29:28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  		switch(this.edit){
  			case 'minute':{
          if(!cyclic){
            if(val >0 && minutes == 59){
              return;
            }
            if(val < 0 && minutes == 0){
              return;
            }
          }
          this.time.setMinutes( (this.time.getMinutes()+val) % 60 );
  				return;
  			}
  			case 'hour':{
          let newHours = (this.time.getHours()+val) % 24;
          if(!cyclic){
            if(val > 0 && hours == 23){
              newHours = 23;
            }
            if(val < 0 && hours == 0){
              newHours = 0;
            }
          }
          this.time.setHours(newHours);
  				return;
  			}
  			case 'day':{
          let newDay = day+val;
          if(cyclic){
            if(newDay < 1){
              newDay = moduls[month];
            }
            if(newDay > moduls[month]){
              newDay = 1;
            }
          }else{
            if(newDay < 1){
              newDay = 1;
            }
            if(newDay > moduls[month]){
              newDay = moduls[month];
            }
          }

          this.time = new Date(year,month,newDay,hours,minutes,seconds);
          
          return;
  			}
  			case 'month':{
          let newMonth = ( (month+val)%(12) );
          if(!cyclic){
            if(month == 11 && val > 0){
              newMonth = 11;
            }
            if(month == 0 && val < 0){
              newMonth = 0;
            }
          }
          let newDay = day;

          while(newDay > moduls[newMonth]){

            newDay--;
          }
          this.time = new Date(year,newMonth,newDay,hours,minutes,seconds);

  				return;
  			}
  			case 'year':{
          if(this.time.getFullYear() == 2099 && val > 0){
            if(cyclic){
              this.time.setFullYear(2001);
            }
            return;
          }
          if(this.time.getFullYear() == 2001 && val < 0){
            if(cyclic){
              this.time.setFullYear(2099);
            }
            return;
          }
          
  				this.time.setFullYear(this.time.getFullYear()+val);
  				return;
  			}
  			default:{
  				this.debug("Unknown edit: "+this.edit);
  			}
  		}
  	}
  	decrease(val?:number){
  		if(!val){
  			val=1;
  		}
  		this.increase(-1*val);
  	}
    _panSkip=3;
    _panCount=0;
  	parseEvent(event){
  		switch(event){
  			case 'reinitTemplate':{
  				return;
  			}
        case 'panup':{
          this._panCount++;
          if(this._panCount % this._panSkip != 0){
            return;
          }
        }
  			case 'up':{
  				this.increase();
  				return;
  			}
        case 'pandown':{
          this._panCount++;
          if(this._panCount % this._panSkip != 0){
            return;
          }

        }
  			case 'down':{
  				this.decrease();
  				return;
          
  			}
  			case 'confirm':{
          this.debug("Got OnConfirm.");
          let confirmation = null;
  				let currentIndex = this.edits.indexOf(this.edit);
  				if(currentIndex < this.edits.length -1){
  					this.edit = this.edits[ (currentIndex + 1)%this.edits.length ];
  				}else{
            if(this.time != undefined){
              this.debug("sending "+this.time.toISOString() + " to onconfirm-method");
              confirmation = this.menuService.currentNode.onConfirm(this.time);
              if(confirmation != null){
                this.debug("passing confirmation: "+confirmation.toString());
              }
            }else{
              this.debug("Time was null. Nothing set.");
            }
            if(this.menuService.currentNode.hasTarget()){
              let target = this.menuService.currentNode.getTargetNode();
              if(target){
                if(confirmation != null){
                this.debug("passing confirmation: "+confirmation.toString() + " to target : "+target.getIdentifier());
              }
                this.menuService.goto(target,confirmation);
                return;
              }
            }

  					if(this.menuService.hasNextMenuItem()){
  						this.menuService.selectNextMenuItem();
              return;
  					}

  				}
  				return;
  			}
  			case 'back':{  
          let currentIndex = this.edits.indexOf(this.edit);
          
          if(currentIndex > 0){
            this.edit = this.edits[ (currentIndex - 1 )%this.edits.length];
            return;
          }
          this.debug("BACK PRESSED!");
          if(this.menuService.getCurrentNode().hasBackTarget()){
            let backTarget = this.menuService.getCurrentNode().getBackTargetNode();
            if(backTarget){
              this.debug("GOING TO BACKTARGET: "+backTarget.getIdentifier());
              this.menuService.goto(backTarget);
              return;
            }
          }
  				if(currentIndex > 0){
  					this.edit = this.edits[ (currentIndex - 1 )%this.edits.length];
            return;
  				}else{
  					if(this.menuService.hasPreviousMenuItem()){
  						this.menuService.selectPreviousMenuItem();
              return;
  					}
  				}
          this.menuService.hierarchyUp(true);
          this.menuService.hierarchyUp();
          

  				return;
  			}
  		}
  	}
    get lightSubtitle(){
      return this.hasParameter('lightSubtitle');
    }
    get lightTitle(){
      return this.hasParameter('lightTitle');
    }
    get lightText(){
      return this.hasParameter('lightText');
    }
  	eventSubscription:any;
    hasParameter(str:string){
      return this.menuService.hasParameter(str);
    }
    getSubTitle(){
      this.subtitle;
    }
    
	ngOnInit() {
    this.debug("Starting off with new date.");
    this.time = new Date(this.ioService.getCurrentTime().getTime());
    this.debug("Loading time from ioService: "+this.time);
		this.eventSubscription = this.ioService.inputs.events$.subscribe(
  			(event)=>{
  				this.parseEvent(event);
  			}
			);
  		this.title = this.menuService.currentNode.getTitle();
  		this.subtitle = this.menuService.currentNode.getSubTitle();
  		this.edits = new Array<string>();
      let existingValue = this.menuService.currentNode.getValue();
      if(existingValue != null && existingValue != undefined && existingValue != ""){
        this.debug("Using existing time.["+existingValue+"]");
        this.time = new Date(parseInt(existingValue));
        if(this.time == undefined || this.time == null){
          this.debug("Read empty date.");
          this.time = new Date();
        }
      }

  		this.template_parameters=this.menuService.currentNode.getTemplateParameters();
     
  		if(this.menuService.hasParameter('time')){
  			this.debug("time");
  			this.mode="time";
  			this.edits.push('hour');
  			this.edits.push('minute')
  		}
  		if(this.menuService.hasParameter('date')){
  			this.debug("date.");
  			this.mode="date";
  			this.edits.push('day')
  			this.edits.push('month');
  			this.edits.push('year');
  		}

  		this.edit = this.edits[0];
  	}
    getText(id){
      return this.menuService.getCurrentNode().getText(id);
    }
  	ngOnDestroy(){
  		this.eventSubscription.unsubscribe();
  	}
    
    debug(msg:string):void{
      if(this._debug){
        console.log("TimesetComponent: "+msg);
      }
    }
}
